import { useTranslation } from "react-i18next";
import { ReactComponent as SelectStore } from "../../../assets/map-assets/selectStoreBiogents.svg";
import { ReactComponent as PhoneLogo } from "../../../assets/map-assets/phone.svg";
import { ReactComponent as WebsiteLogo } from "../../../assets/map-assets/website.svg";
import { updateSelectedStore } from "../../utils.js";
import { useMediaQuery } from "react-responsive";
import clsx from "clsx";
import style from "./style.module.scss";

const StoreTile = ({
  store,
  isMain,
  setSelectedReseller,
  map,
  userLocation,
}) => {
  const { t } = useTranslation();
  const isTablet = useMediaQuery({ query: "(max-width: 992px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  const chooseNewStore = () => {
    if (!map) return;

    updateSelectedStore(map, store);

    const longitude =
      isTablet && !isMobile
        ? store.geometry.coordinates[0] - 0.15
        : store.geometry.coordinates[0];
    map.flyTo({
      center: [longitude, store.geometry.coordinates[1]],
      zoom: 12,
      speed: 1,
    });

    setSelectedReseller(store);
  };

  const calculateDistance = () => {
    if (!userLocation) return null;

    // Rayon de la Terre en kilomètres
    const R = 6371;

    // Conversion des coordonnées en radians
    const lat1 = (userLocation.latitude * Math.PI) / 180;
    const lon1 = (userLocation.longitude * Math.PI) / 180;
    const lat2 = (store.geometry.coordinates[1] * Math.PI) / 180;
    const lon2 = (store.geometry.coordinates[0] * Math.PI) / 180;

    // Différences de coordonnées
    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;

    // Formule de Haversine
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    // Formater la distance
    if (distance < 1) {
      // Si moins d'1 km, afficher en mètres
      return `${Math.round(distance * 1000)}m`;
    }
    // Sinon afficher en km avec une décimale
    return `${distance.toFixed(1)}km`;
  };

  return (
    <div
      className={clsx(style.storeTileContainer, isMain && style.isSelected)}
      onClick={() => !isMain && chooseNewStore()}
    >
      <div className={style.storeTileContent}>
        {store.properties.title && (
          <h2 className={style.storeTileTitle}>{store.properties.title}</h2>
        )}
        {store.properties.address && (
          <p className={style.storeTileAddress}>{store.properties.address}</p>
        )}
        <p className={style.storeTileCity}>
          {store.properties.zipcode && store.properties.zipcode}{" "}
          {store.properties.city && store.properties.city}
        </p>
        {store.properties.phone && (
          <a
            href={"tel:" + store.properties.phone}
            className={style.storeTilePhone}
          >
            <PhoneLogo className={style.phoneLogo} />
            <span>{store.properties.phone}</span>
          </a>
        )}
        {store.properties.url && (
          <a
            href={
              store.properties.url.startsWith("http")
                ? store.properties.url
                : `https://${store.properties.url}`
            }
            className={style.storeTileWebsite}
          >
            <WebsiteLogo className={style.websiteLogo} />
            <span>{t("Website")}</span>
          </a>
        )}
      </div>
      <div className={style.rightPart}>
        <a
          href={`https://www.google.com/maps?q=${store.geometry.coordinates[1]},${store.geometry.coordinates[0]}`}
          target="_blank"
          rel="noreferrer"
        >
          <SelectStore className={style.direction} />
        </a>
        {userLocation && (
          <p className={style.distance}>{calculateDistance()}</p>
        )}
      </div>
    </div>
  );
};

export default StoreTile;
